/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateEmailIndexPathParams, CandidateEmailIndexResponse } from '../types/CandidateEmailIndex'

/**
 * GET /candidates/:candidateId/emails
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::index
 */
export async function candidateEmailIndex(
	candidateId: CandidateEmailIndexPathParams['candidateId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateEmailIndexResponse>> {
	return axiosInstance.get(`/candidates/${candidateId}/emails`, config)
}
